module.exports = __webpack_public_path__ + "static/media/tcc.857cf96a.png";